module.exports = __webpack_public_path__ + "img/Bodice-Back-Jb-Kc-La.f1045965.png";